/* eslint-disable @typescript-eslint/no-explicit-any */
import type { TableSortValue } from "@src/shared/constants/sort-order.constants";
import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";

export interface CategoryOption {
  id: number;
  name: string;
}

export class CategoryService {
  async getAllCategories(query?: { name?: string; orderBy?: string; orderDirection?: TableSortValue }) {
    return apiService.get("/categories/all", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getCategories(query?: Record<string, any>) {
    return apiService.get("/categories", {
      params: sanitizeQueryParams(query || {}),
    });
  }
}

export const categoryService = new CategoryService();
